import script from "./ProductRenovationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductRenovationForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProductRenovationForm.vue?vue&type=style&index=0&id=2a325011&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a325011"]])

export default __exports__